import { render } from "./SbpPaidBills.vue?vue&type=template&id=59c21c17"
import script from "./SbpPaidBills.vue?vue&type=script&lang=js"
export * from "./SbpPaidBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__